<template>
  <layout
    :titlePage="getNameRouter() + ' - Layouts'"
    :route="{ name: 'convites' }"
  >
    <div class="columns columns--full is-vcentered save-the-date-layout">
      <div class="column">
        <h1
          class="c-header-guests__title is-size-4 has-text-grey-darker has-text-weight-bold"
          v-if="hasToShowNewMenu"
        >
          {{ pageTitle }}
        </h1>
        <div class="container has-text-centered">
          <p class="save-the-date-layout__title">
            Selecione o modelo que você prefere
          </p>
          <cardsOfLayouts :arrayLayouts="layouts[getNameTypeLayout()]" />
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import cardsOfLayouts from '@/components/Invites/BaseCardLayout.vue'

import floraniInvite from '@/assets/img/invites/invite/florani.png'
import porDoSolInvite from '@/assets/img/invites/invite/por-do-sol.jpg'
import algasMarinhasInvite from '@/assets/img/invites/invite/algas-marinhas.jpg'
import conchasNoOceanoInvite from '@/assets/img/invites/invite/conchas-no-oceano.jpg'
import floralRusticInvite from '@/assets/img/invites/invite/floral-rustico.png'
import floralNightInvite from '@/assets/img/invites/invite/floral-night.png'
import floralCleanInvite from '@/assets/img/invites/invite/floral-clean.png'
import floralElleganceInvite from '@/assets/img/invites/invite/floral-ellegance.png'
import floralMaritimoInvite from '@/assets/img/invites/invite/floral-maritimo.png'
import classicoInvite from '@/assets/img/invites/invite/classico.jpg'
import rusticoInvite from '@/assets/img/invites/invite/rustico.jpg'
import romanticoInvite from '@/assets/img/invites/invite/romantico.jpg'
import modernoInvite from '@/assets/img/invites/invite/moderno.jpg'
import aquarelaInvite from '@/assets/img/invites/invite/aquarela.jpg'
import pinturaInvite from '@/assets/img/invites/invite/pintura.jpg'

import florani from '@/assets/img/invites/simple/florani.png'
import algasMarinhas from '@/assets/img/invites/simple/algas-marinhas.jpg'
import porDoSol from '@/assets/img/invites/simple/por-do-sol.jpg'
import conchasNoOceano from '@/assets/img/invites/simple/conchas-no-oceano.jpg'
import floralRustic from '@/assets/img/invites/simple/floral-rustic.png'
import floralNight from '@/assets/img/invites/simple/floral-night.png'
import floralClean from '@/assets/img/invites/simple/floral-clean.png'
import floralEllegance from '@/assets/img/invites/simple/floral-ellegance.png'
import floralMaritimo from '@/assets/img/invites/simple/floral-maritimo.png'
import classico from '@/assets/img/invites/simple/classico.png'
import rustico from '@/assets/img/invites/simple/rustico.png'
import romantico from '@/assets/img/invites/simple/romantico.png'
import moderno from '@/assets/img/invites/simple/moderno.png'
import aquarela from '@/assets/img/invites/simple/aquarela.png'
import pintura from '@/assets/img/invites/simple/pintura.png'

import floraniC from '@/assets/img/invites/communication/florani.png'
import porDoSolC from '@/assets/img/invites/communication/por-do-sol.jpg'
import algasMarinhasC from '@/assets/img/invites/communication/algas-marinhas.jpg'
import conchasNoOceanoC from '@/assets/img/invites/communication/conchas-no-oceano.jpg'
import floralRusticC from '@/assets/img/invites/communication/floral-rustico.jpg'
import floralNightC from '@/assets/img/invites/communication/floral-night.jpg'
import floralCleanC from '@/assets/img/invites/communication/floral-clean.jpg'
import floralElleganceC from '@/assets/img/invites/communication/floral-ellegance.jpg'
import floralMaritimoC from '@/assets/img/invites/communication/floral-maritimo.jpg'
import classicoC from '@/assets/img/invites/communication/classicoC.jpg'
import rusticoC from '@/assets/img/invites/communication/rusticoC.jpg'
import romanticoC from '@/assets/img/invites/communication/romanticoC.jpg'
import modernoC from '@/assets/img/invites/communication/modernoC.jpg'
import aquarelaC from '@/assets/img/invites/communication/aquarelaC.jpg'
import pinturaC from '@/assets/img/invites/communication/pinturaC.jpg'

export default {
  components: {
    layout,
    cardsOfLayouts,
  },

  data() {
    return {
      layouts: {
        oficial: [
          {
            name: 'Floranny',
            title: 'floranny',
            img: floraniInvite,
          },
          {
            name: 'Água do Mar - Pôr do sol',
            title: 'por-sol',
            img: porDoSolInvite,
          },
          {
            name: 'Água do Mar - Algas marinhas',
            title: 'algas-marinhas',
            img: algasMarinhasInvite,
          },
          {
            name: 'Água do Mar - Conchas no oceano',
            title: 'conchas-oceano',
            img: conchasNoOceanoInvite,
          },
          {
            name: 'Floral Night',
            title: 'floral-night',
            img: floralNightInvite,
          },
          {
            name: 'Floral Rústico',
            title: 'floral-rustico',
            img: floralRusticInvite,
          },
          {
            name: 'Floral Clean',
            title: 'floral-clean',
            img: floralCleanInvite,
          },
          {
            name: 'Floral Ellegance',
            title: 'floral-ellegance',
            img: floralElleganceInvite,
          },
          {
            name: 'Floral Maritimo',
            title: 'floral-maritimo',
            img: floralMaritimoInvite,
          },
          {
            name: 'Clássico',
            title: 'classico',
            img: classicoInvite,
          },
          {
            name: 'Rústico',
            title: 'rustico',
            img: rusticoInvite,
          },
          {
            name: 'Romântico',
            title: 'romantico',
            img: romanticoInvite,
          },
          {
            name: 'Moderno',
            title: 'moderno',
            img: modernoInvite,
          },
          {
            name: 'Aquarela',
            title: 'aquarela',
            img: aquarelaInvite,
          },
          {
            name: 'Pintura',
            title: 'pintura',
            img: pinturaInvite,
          },
        ],
        'save-the-date': [
          {
            name: 'Floranny',
            title: 'floranny',
            img: florani,
          },
          {
            name: 'Água do Mar - Pôr do sol',
            title: 'por-sol',
            img: porDoSol,
          },
          {
            name: 'Água do Mar - Algas marinhas',
            title: 'algas-marinhas',
            img: algasMarinhas,
          },
          {
            name: 'Água do Mar - Conchas no oceano',
            title: 'conchas-oceano',
            img: conchasNoOceano,
          },
          {
            name: 'Floral Night',
            title: 'floral-night',
            img: floralNight,
          },
          {
            name: 'Floral Rústico',
            title: 'floral-rustico',
            img: floralRustic,
          },
          {
            name: 'Floral Clean',
            title: 'floral-clean',
            img: floralClean,
          },
          {
            name: 'Floral Ellegance',
            title: 'floral-ellegance',
            img: floralEllegance,
          },
          {
            name: 'Floral Maritimo',
            title: 'floral-maritimo',
            img: floralMaritimo,
          },
          {
            name: 'Clássico',
            title: 'classico',
            img: classico,
          },
          {
            name: 'Rústico',
            title: 'rustico',
            img: rustico,
          },
          {
            name: 'Romântico',
            title: 'romantico',
            img: romantico,
          },
          {
            name: 'Moderno',
            title: 'moderno',
            img: moderno,
          },
          {
            name: 'Aquarela',
            title: 'aquarela',
            img: aquarela,
          },
          {
            name: 'Pintura',
            title: 'pintura',
            img: pintura,
          },
        ],
        comunicado: [
          {
            name: 'Floranny',
            title: 'floranny',
            img: floraniC,
          },
          {
            name: 'Água do Mar - Pôr do sol',
            title: 'por-sol',
            img: porDoSolC,
          },
          {
            name: 'Água do Mar - Algas marinhas',
            title: 'algas-marinhas',
            img: algasMarinhasC,
          },
          {
            name: 'Água do Mar - Conchas no oceano',
            title: 'conchas-oceano',
            img: conchasNoOceanoC,
          },
          {
            name: 'Floral Night',
            title: 'floral-night',
            img: floralNightC,
          },
          {
            name: 'Floral Rústico',
            title: 'floral-rustico',
            img: floralRusticC,
          },
          {
            name: 'Floral Clean',
            title: 'floral-clean',
            img: floralCleanC,
          },
          {
            name: 'Floral Ellegance',
            title: 'floral-ellegance',
            img: floralElleganceC,
          },
          {
            name: 'Floral Maritimo',
            title: 'floral-maritimo',
            img: floralMaritimoC,
          },
          {
            name: 'Clássico',
            title: 'classico',
            img: classicoC,
          },
          {
            name: 'Rústico',
            title: 'rustico',
            img: rusticoC,
          },
          {
            name: 'Romântico',
            title: 'romantico',
            img: romanticoC,
          },
          {
            name: 'Moderno',
            title: 'moderno',
            img: modernoC,
          },
          {
            name: 'Aquarela',
            title: 'aquarela',
            img: aquarelaC,
          },
          {
            name: 'Pintura',
            title: 'pintura',
            img: pinturaC,
          },
        ],
      },
    }
  },

  computed: {
    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },

    pageTitle() {
      const router = this.$router.currentRoute.params.tipo

      if (router === 'save-the-date') {
        return 'Save the date - Layouts'
      } else if (router === 'oficial') {
        return 'Convite oficial - Layouts'
      } else if (router === 'comunicado') {
        return 'Comunicado - Layouts'
      }

      return ''
    },
  },

  methods: {
    getNameTypeLayout() {
      return this.$router.currentRoute.params.tipo
    },

    getNameRouter() {
      const router = this.$router.currentRoute.params.tipo

      if (router === 'save-the-date') {
        return 'Save the date'
      } else if (router === 'oficial') {
        return 'Convite oficial'
      } else {
        return router.charAt(0).toUpperCase() + router.slice(1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.layout::before {
  content: none;
}
.save-the-date-layout {
  padding-top: 50px;
  padding-bottom: 40px;
}
</style>
